// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/arrival-radio-sequence.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/arrival-radio-sequence/arrival-radio-sequence.js';

mount([g0]);
